import styled from "@emotion/styled";
import { Upload } from "antd";

export const StyledUpload = styled(Upload)`
.ant-upload-select {
  height: fit-content;
}
`;
